module.exports = __webpack_public_path__ + "img/seating-boardroom.15f4a961.svg";